import Gen1TrunkingOrderRepeaterSerial from './Gen1TrunkingOrderRepeaterSerial';
import Gen1TrunkingOrderItem from './Gen1TrunkingOrderItem';
import Gen1TrunkingOrderLicenseKeyFile from './Gen1TrunkingOrderLicenseKeyFile';
import { GEN1_STATUS } from '../../Components/Gen1/gen1Status';

/**
 * Gen1TrunkingOrderHeaders テーブル用 ViewModel（Application および Order Detail / History で利用）
 * API レスポンスのマッピング用。
 */
export default class Gen1TrunkingOrderHeader {
    constructor(dataObject = null) {
        this.id = 0;
        // 新規作成時の既定は draft
        this.Status = GEN1_STATUS.DRAFT;
        this.ContactName = '';
        this.ContactEmail = '';
        this.AddressLineOne = '';
        this.AddressLineTwo = '';
        this.AddressLineThree = '';
        this.City = '';
        this.State = '';
        this.Zip = '';
        this.Country = '';
        this.Telephone = '';
        this.CustomerAddressBookId = 0;
        this.ManufactureRep = '';
        this.SystemType = ''; // New System | Existing System
        this.SystemId = '';
        this.DealerOrderNumber = '';
        this.IncludePurchasedRepeaters = false;
        this.AdditionalNotes = '';
        this.RequestedDate = null;
        this.ConfirmedDate = null;
        this.CompletedDate = null;
        this.CreatedDate = null;
        this.CreatedByUserId = '';
        this.UpdateDate = null;
        this.UpdateByUserId = null;
        this.Revision = 1;

        // Gen1 注文一覧 API のレスポンスをマッピングするための販売注文番号（サーバーがリピータシリアルから集約して返す）
        this.OrderNumber = '';

        this.Gen1TrunkingOrderRepeaterSerials = [];
        this.Gen1TrunkingOrderItem = new Gen1TrunkingOrderItem();
        this.Gen1TrunkingOrderLicenseKeyFiles = [];

        if (dataObject) {
            try {
                this.id = dataObject.id ?? 0;
                this.Status = dataObject.Status ?? this.Status;
                this.ContactName = dataObject.ContactName ?? '';
                this.ContactEmail = dataObject.ContactEmail ?? '';
                this.AddressLineOne = dataObject.AddressLineOne ?? '';
                this.AddressLineTwo = dataObject.AddressLineTwo ?? '';
                this.AddressLineThree = dataObject.AddressLineThree ?? '';
                this.City = dataObject.City ?? '';
                this.State = dataObject.State ?? '';
                this.Zip = dataObject.Zip ?? '';
                this.Country = dataObject.Country ?? '';
                this.Telephone = dataObject.Telephone ?? '';
                this.CustomerAddressBookId =
                    dataObject.CustomerAddressBookId ?? 0;
                this.ManufactureRep = dataObject.ManufactureRep ?? '';
                this.SystemType = dataObject.SystemType ?? '';
                this.SystemId = dataObject.SystemId ?? '';
                this.DealerOrderNumber =
                    dataObject.DealerOrderNumber ??
                    dataObject.dealerOrderNumber ??
                    '';
                this.IncludePurchasedRepeaters =
                    dataObject.IncludePurchasedRepeaters ?? false;
                this.AdditionalNotes = dataObject.AdditionalNotes ?? '';
                const requestedSrc = dataObject.RequestedDate;
                this.RequestedDate = requestedSrc
                    ? new Date(requestedSrc)
                    : null;
                const confirmedSrc = dataObject.ConfirmedDate;
                this.ConfirmedDate = confirmedSrc
                    ? new Date(confirmedSrc)
                    : null;
                const completedSrc = dataObject.CompletedDate;
                this.CompletedDate = completedSrc
                    ? new Date(completedSrc)
                    : null;
                const createdSrc = dataObject.CreatedDate;
                this.CreatedDate = createdSrc ? new Date(createdSrc) : null;
                this.CreatedByUserId = dataObject.CreatedByUserId ?? '';
                const updateSrc = dataObject.UpdateDate;
                this.UpdateDate = updateSrc ? new Date(updateSrc) : null;
                this.UpdateByUserId = dataObject.UpdateByUserId ?? '';
                this.Revision = dataObject.Revision ?? 1;

                this.OrderNumber =
                    dataObject.OrderNumber ?? dataObject.orderNumber ?? '';

                const repeaterSerialsRaw =
                    dataObject.Gen1TrunkingOrderRepeaterSerials ?? [];
                this.Gen1TrunkingOrderRepeaterSerials = Array.isArray(
                    repeaterSerialsRaw
                )
                    ? repeaterSerialsRaw.map(
                          (repeaterSerial) =>
                              new Gen1TrunkingOrderRepeaterSerial(
                                  repeaterSerial
                              )
                      )
                    : [];

                const itemRaw = dataObject.Gen1TrunkingOrderItem;
                this.Gen1TrunkingOrderItem =
                    itemRaw != null
                        ? new Gen1TrunkingOrderItem(itemRaw)
                        : new Gen1TrunkingOrderItem();

                const licenseKeyFilesRaw =
                    dataObject.Gen1TrunkingOrderLicenseKeyFiles ?? [];
                this.Gen1TrunkingOrderLicenseKeyFiles = Array.isArray(
                    licenseKeyFilesRaw
                )
                    ? licenseKeyFilesRaw.map(
                          (x) => new Gen1TrunkingOrderLicenseKeyFile(x)
                      )
                    : [];
            } catch (e) {
                throw new Error('Data import error @ Gen1TrunkingOrderHeader.');
            }
        }
    }
}
